/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const YellowStarIcon = /*#__PURE__*/ createSvgIcon(
  'YellowStarIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M17.51 7.77h-5.32l-1.78-5.46a.45.45 0 00-.85 0l-1.8 5.46H2.45A.45.45 0 002 8.2a.43.43 0 00.16.35L6.66 12l-1.72 5.43a.45.45 0 00.3.56.43.43 0 00.39-.08L10 14.53l4.38 3.38a.44.44 0 00.69-.48L13.33 12l4.49-3.44a.43.43 0 00-.03-.73.501.501 0 00-.28-.06z"
            fill="#FFC936"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7 1.547a.947.947 0 011.199.62l1.666 5.111 4.967-.003a.923.923 0 01.794.388.922.922 0 01-.216 1.294l-4.19 3.212 1.621 5.083a.931.931 0 01-1.475 1.03l-4.05-3.132-4.053 3.163a.934.934 0 01-.838.158.94.94 0 01-.643-1.177l.002-.006 1.618-5.094-4.207-3.213a.94.94 0 01.612-1.702h4.91L9.111 2.13a.94.94 0 01.58-.58l.009-.003zm7.656 6.728l-5.517.004L10 2.632 8.14 8.28H2.623l4.645 3.547-1.773 5.584 4.518-3.526 4.519 3.494-1.78-5.575 4.604-3.528z"
            fill="#A32E00"
          />
        </>
      ),
    },
  },
  false
);

export default YellowStarIcon;
